export enum EPLITrainerDevelopmentPlanAttendeeCompletionStatus {
  Completed = 'Completed',
  PartiallyCompleted = 'Partially completed',
  DidNotComplete = 'Did not complete'
}
